import { render, staticRenderFns } from "./AlocaGrupoLinhaDialog.vue?vue&type=template&id=19a62643&"
import script from "./AlocaGrupoLinhaDialog.vue?vue&type=script&lang=js&"
export * from "./AlocaGrupoLinhaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports